module.exports = __webpack_public_path__ + "static/static-zoom-94cc58f460cdab1d7e5b11e84bac52e5.jpg";